import { Text } from '@iwoca/orion';
import { upperFirst } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { useGetShareholdersData } from './useGetShareholdersData';
import { FormattedName } from '../../../../../iwIntlProvider/FormattedName';
import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';

const SHAREHOLDERS_PATH = '/funding-requirements/shareholders';

type TShareholdersStepProps = { status: TFundingRequirementStatus };

export const ShareholdersStep = ({ status }: TShareholdersStepProps) => {
    const people = useGetShareholdersData();

    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.shareholders_step.list_title"
                    defaultMessage="Add your directors and major shareholders"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.estimated_time"
                    defaultMessage="~ {minutes} mins"
                    values={{ minutes: 5 }}
                />
            }
            href={SHAREHOLDERS_PATH}
            status={status}
            completedView={
                <div>
                    <Text className="text-m font-med text-primary-10">
                        <FormattedMessage
                            id="_.funding_requirements.shareholders_step.completed_title"
                            defaultMessage="Company shareholders"
                        />
                    </Text>
                    <div className="my-s flex flex-wrap items-center gap-m text-s text-structure-40">
                        {people.map((person) => (
                            <span key={person.uid} className="font-med">
                                {person.title && `${upperFirst(person.title)} `}
                                <FormattedName
                                    firstName={person.firstName}
                                    lastName={person.lastName}
                                />
                            </span>
                        ))}
                    </div>
                </div>
            }
        />
    );
};
